export default {
  "overviewTitle": "商协会套餐数据概览",
  "core": "核心指标",
  "noPrevious": "暂无上月数据",
  "trendTitle": "近 6 个月商协会套餐收入趋势",
  "topTitle": "Top 10 商协会开通企业",
  "rank": "排名",
  "association": "协会 / 组织",
  "planVersion": "套餐版本",
  "amountActivated": "开通金额",
  "noActivations": "暂无商协会开通记录",
  "sourceDistribution": "商协会来源分布",
  "sourceCenter": "开通\n来源",
  "statusDistribution": "商协会状态分布",
  "statusCenter": "协会\n状态",
  "monthActivated": "本月开通协会",
  "monthRevenue": "本月套餐收入",
  "totalRevenue": "累计套餐收入",
  "totalActivated": "累计开通协会",
  "planTitle": "商协会套餐管理",
  "addPlan": "新增套餐",
  "planGuide": "套餐用于平台后续为指定组织开通商协会小程序服务。本页只配置套餐，不会自动开通组织或生成收费记录。",
  "defaultDescription": "适用于商协会组织的小程序服务。",
  "free": "免费",
  "displayFeatures": "展示功能",
  "edit": "编辑",
  "delete": "删除",
  "emptyPlans": "尚未配置商协会套餐",
  "editPlan": "编辑套餐",
  "basic": "基本信息",
  "name": "套餐名称",
  "tag": "标签",
  "tagPlaceholder": "如：热门、旗舰",
  "price": "价格（元）",
  "duration": "有效期",
  "permanent": "永久",
  "year": "按年",
  "durationYears": "有效期（年）",
  "theme": "主题色",
  "status": "状态",
  "listed": "上架",
  "unlisted": "下架",
  "description": "说明",
  "features": "包含功能",
  "onePerLine": "每行一项",
  "featurePlaceholder": "每行一项，例如：\n活动报名\n会员管理\n首页装修",
  "featureHint": "仅用于套餐页展示，不影响本期实际权限。每行一项，最多 30 项。",
  "cancel": "取消",
  "save": "保存",
  "home": "首页装修",
  "members": "会员管理",
  "join": "申请入会",
  "contacts": "通讯录",
  "associationIntro": "商会介绍",
  "articles": "新闻管理",
  "organization": "组织架构",
  "activities": "活动管理",
  "albums": "活动相册",
  "fees": "会费缴纳",
  "blue": "蓝",
  "purple": "紫",
  "cyan": "青",
  "green": "绿",
  "orange": "橙",
  "pink": "粉",
  "gray": "灰",
  "nameRequired": "请输入套餐名称",
  "priceRequired": "请输入价格",
  "featuresRequired": "请填写展示功能",
  "yearsRequired": "请设置有效期年数",
  "permanentValid": "永久有效",
  "saved": "套餐已保存",
  "deleteTitle": "删除套餐",
  "deleted": "套餐已删除",
  "recordsTitle": "开通记录",
  "recordsHint": "这里展示已支付或已人工开通的商协会服务授权，可暂停、恢复或按年续期。",
  "company": "组织",
  "plan": "套餐",
  "amount": "金额",
  "activatedAt": "开通时间",
  "active": "开通中",
  "paused": "已暂停",
  "actions": "操作",
  "pause": "暂停",
  "resume": "恢复",
  "renew": "续期一年",
  "emptyRecords": "暂无开通记录",
  "updated": "已更新",
  "renewTitle": "服务续期",
  "navTitle": "商协会套餐",
  "navOverview": "数据概览",
  "navPlans": "商协会套餐",
  "navRecords": "开通记录",
  "change": "环比",
  "trendNote": "单位：元 · 峰值 {amount}",
  "associationCount": "{n} 家",
  "years": "{n} 年",
  "defaultFeatures": "首页装修\n活动管理\n会员管理",
  "deleteConfirm": "确认删除“{name}”吗？",
  "renewConfirm": "确认将“{name}”续期一年吗？",
  "sourceSelf": "官网自助开通",
  "sourceProxy": "对接人邀请开通",
  "sourceEnterprise": "企业使用者推荐",
  "normal": "正常",
  "soon30": "即将到期(30天内)",
  "expired": "已到期"
}
